export default class ActionTarget {
    private corporationIds: number[];
    private projectIds: number[];
    private buildingIds: number[];
    private propertyIds: number[];

    constructor(
        corporationIds: number[] = [],
        projectIds: number[] = [],
        buildingIds: number[] = [],
        propertyIds: number[] = [],
    ) {
        this.corporationIds = corporationIds;
        this.projectIds = projectIds;
        this.buildingIds = buildingIds;
        this.propertyIds = propertyIds;
    }

    public getTargets() {
        return {
            corporationIds: this.corporationIds,
            projectIds: this.projectIds,
            buildingIds: this.buildingIds,
            propertyIds: this.propertyIds,
        };
    }
}
